import React from 'react';

const Button = ({ children, active, onClick, link, position = {} }) => {
  const fixedPosition = {
    ...position,
    transform: `${
      position.position === 'absolute' && position.left === '50%'
        ? 'translateX(-50%)'
        : position.position === 'absolute' && position.right === '50%'
        ? 'translateX(50%)'
        : undefined
    }`
  };

  const InnerButton = () => (
    <button
      type="button"
      className={active ? 'active' : undefined}
      onClick={onClick}
      style={link === undefined ? fixedPosition : undefined}
    >
      {children}
    </button>
  );

  return (
    <>
      {link ? (
        <a href={link} target="_blank" rel="noopener noreferrer" style={fixedPosition}>
          <InnerButton />
        </a>
      ) : (
        <InnerButton />
      )}
    </>
  );
};

export { Button };
